/**
 * 스카이 기종/옵션 UI 처리
 */
export default class OptionSky {
    constructor() {
    }
    getHtml = function(){
        return `
<div class="sky_car a">
    <h2 class="title1">기종선택</h2>
    <div class="flex">
        <div class="left flex_column main-button-area">
            <div class="item flex number-font " data-index="1" data-range="1~22" data-code="100">1<span class="fz_12 fw_semobild   mt-2">톤</span></div>
            <div class="floor"></div>
            <div class="item flex number-font" data-index="2" data-range="5~22" data-code="110">2.5<span class="fz_12 fw_semobild   mt-2">톤</span></div>
            <div class="floor"></div>
            <div class="item flex number-font" data-index="3" data-range="8~22" data-code="120">3.5<span class="fz_12 fw_semobild   mt-2">톤</span></div>
            <div class="floor"></div>
            <div class="item flex number-font" data-index="4" data-range="13~22" data-code="130">5<span class="fz_12 fw_semobild   mt-2">톤</span></div>
            <div class="floor"></div>
            <div class="item flex number-font" data-index="5" data-range="18~22" data-code="140">17<span class="fz_12 fw_semobild   mt-2">톤</span></div>
            <div class="floor"></div>
            <div class="item flex number-font" data-index="6" data-range="22~22" data-code="150">25<span class="fz_12 fw_semobild   mt-2">톤</span></div>
            <div class="floor"></div>
        </div>
        <div class="right flex_column sub-button-area">
            <div class="flex" data-index="1">
                <div class="item flex number-font" data-index="1" data-code="16">16<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="2" data-code="18">18<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="3" data-code="20">20<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="4" data-code="21">21<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font op0">0</div>
            </div>
            <div class="flex floor">
                <p class="flex" data-index="1">3~4층</p>
                <p class="flex" data-index="2">4층</p>
                <p class="flex" data-index="3">4~5층</p>
                <p class="flex" data-index="4">5~6층</p>
                <p class="flex op0">0</p>
            </div>
            <div class="flex" data-index="2">
                <div class="item flex number-font" data-index="5" data-code="22">22<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="6" data-code="24">24<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="7" data-code="25">25<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font op0">0</div>
                <div class="item flex number-font op0">0</div>
            </div>
            <div class="flex floor">
                <p class="flex" data-index="5">5층</p>
                <p class="flex" data-index="6">5~6층</p>
                <p class="flex" data-index="7">6층</p>
                <p class="flex op0">0</p>
                <p class="flex op0">0</p>
            </div>
            <div class="flex" data-index="3">
                <div class="item flex number-font" data-index="8" data-code="26">26<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="9" data-code="28">28<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="10" data-code="30">30<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="11" data-code="32">32<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="12" data-code="34">34<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
            </div>
            <div class="flex floor">
                <p class="flex" data-index="8">5~6층</p>
                <p class="flex" data-index="9">6~7층</p>
                <p class="flex" data-index="10">7층</p>
                <p class="flex" data-index="11">7.5층</p>
                <p class="flex" data-index="12">8~9층</p>
            </div>
            <div class="flex" data-index="4">
                <div class="item flex number-font" data-index="13" data-code="38">38<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="14" data-code="40">40<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="15" data-code="45">45<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="16" data-code="50">50<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="17" data-code="54">54<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
            </div>
            <div class="flex floor">
                <p class="flex" data-index="13">10층</p>
                <p class="flex" data-index="14">12층</p>
                <p class="flex" data-index="15">13~15층</p>
                <p class="flex" data-index="16">15~16층</p>
                <p class="flex" data-index="17">17층</p>
            </div>
            <div class="flex" data-index="5">
                <div class="item flex number-font" data-index="18" data-code="58">58<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="19" data-code="65">65<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="20" data-code="70">70<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font" data-index="21" data-code="75">75<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font op0">0</div>
            </div>
            <div class="flex floor">
                <p class="flex" data-index="18">18층</p>
                <p class="flex" data-index="19">21층</p>
                <p class="flex" data-index="20">23층</p>
                <p class="flex" data-index="21">25층</p>
                <p class="flex op0">0</p>
            </div>
            <div class="flex" data-index="6">
                <div class="item flex number-font" data-index="22" data-code="90">90<span class="fz_11 fw_medium ml-05  mt-3">M</span></div>
                <div class="item flex number-font op0">0</div>
                <div class="item flex number-font op0">0</div>
                <div class="item flex number-font op0">0</div>
                <div class="item flex number-font op0">0</div>
            </div>
            <div class="flex floor">
                <p class="flex" data-index="22">30층</p>
                <p class="flex op0">0</p>
                <p class="flex op0">0</p>
                <p class="flex op0">0</p>
                <p class="flex op0">0</p>
            </div>
        </div>
    </div>
    <h2 class="title1">옵션선택</h2>
    <div class="option flex_column">
        <div class="division_3 flex">
            <div class="item flex " data-value="굴절" data-code="100" data-constraint="Y:S:8,9,14,15,19" data-constraint-errmsg="굴절을 선택할 수 있는 차량은 3.5T(26M,28M), 5T(40M,45M), 17T(65M) 차량만 가능합니다.">
                굴절
            </div>
            <div class="item flex " data-value="윈찌" data-code="140">
                윈찌
            </div>
            <div class="item flex " data-value="단축" data-code="120">
                단축
            </div>
            <select class="item-select flex" data-value="전고">
                <option value="전고">전고</option>
            </select>
        </div>
    </div>
    <div class="car-example"></div>
    <div class="blank"></div>
    <div class="button flex">
        <div class="button_yellow flex apply-data">완료</div>
    </div>
</div>`;
    }
    /**
     * 화면 초기화
     * @param parent OptionWindow 인스턴스
     */
    init = function(parent) {
        this.parent=parent;
        console.log('window.option.sky.init');
        this.parent.load();// 변수 초기화
        this.drawFloor();
        this.parent.drawJungo();// 전고 그리기 ( 최초한번만 )
        this.parent.draw();// 톤수,미터를 그린다.
        this.parent.initMainButtonHandler();// 메인 버튼을 클릭했을때
        this.parent.initSubButtonHandler();// 서브 버튼을 클릭했을때
        this.parent.initOptionHandler();// 옵션버튼 클릭시
        this.parent.initApplyHandler();// 완료버튼 클릭시
    }

    /**
     * 층수를 표시한다.
     */
    drawFloor(){
        if( MEMBER['mem_driver_type']=='수발주자'){
            $('#'+this.parent.id+" .floor").hide();
        }
    }
    /**
     * 기종범위 코드를 얻는다.
     */
    updateRange = function (){
        const self = this;
        const arr = [];
        let code = '';
        // 메인버튼에 설정된 data-code 값을 읽어온다.
        $('#'+this.parent.id+" .main-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            // console.log(idx, self.parent.mainIdx);
            if( idx==self.parent.mainIdx ) code=$(this).attr('data-code');
        });

        // 서브버튼에 설정된 data-value 값을 읽어온다.
        $('#'+this.parent.id+" .sub-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            if( self.parent.subIdxList.includes(idx) ) arr.push( $(this).attr('data-code'));
        });

        const min = Math.min(...arr);
        const max = Math.max(...arr);
        let range = '';
        range = `${code}|${min}~${max}`;
        const data = this.parent.data;
        data['car_range']=range;

    }
}
